"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRendererType = validateRendererType;
function validateRendererType(rendererType, RendererType) {
    if (!RendererType) {
        throw new Error(`renderer "${rendererType}" not found`);
    }
    // @ts-expect-error
    if (!RendererType.ReactComponent) {
        throw new Error(`renderer ${rendererType} has no ReactComponent, it may not be completely implemented yet`);
    }
    return RendererType;
}
